import React from "react"
import {graphql} from "gatsby"
import {GatsbyImage, getImage} from "gatsby-plugin-image"
import Layout from "../components/layout"
import Seo from "../components/seo"
import PostBlocksRenderer from "../components/post-blocks-renderer"
import Headings from "../components/headings"
import Sidebar from "../components/sidebar";
import {Trans} from "gatsby-plugin-react-i18next";
import Newsletter from "../components/newsletter";
import NewsletterBlock from "../components/newsletter-block";

const Post = ({data, pageContext}) => {
    const post = data.strapiPost;
    const urlEncoded = encodeURI(pageContext.canonical);
    // console.log('post', pageContext);

    let newsletterText = 'Find some more beach!';
    if (post.cw_topic && ['fishing', 'sailing'].includes(post.cw_topic.slug)) {
        newsletterText = `Find some more beach for ${post.cw_topic.slug}!`;
    } else if (post.cw_topic && ['snorkel', 'surf'].includes(post.cw_topic.slug)) {
        newsletterText = `Find some more beach for ${post.cw_topic.slug}ing!`;
    } else if (post.cw_region) {
        newsletterText = `Find some more beach in ${post.cw_region.name}!`;
    }

    return (
        <Layout as="post" pageContext={pageContext} data={data}>
            <Headings title={post.Title} pageContext={pageContext}/>
            <main className="mt-8 mb-4">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <PostBlocksRenderer blocks={post.Content || []}/>
                            <NewsletterBlock pageContext={pageContext} text={newsletterText}/>
                            <div className="blog-details__bottom">
                                <p className="blog-details__tags">
                                    <span><Trans>Tags</Trans>:</span>
                                    {post.cw_country && (
                                        <a href={`/${pageContext.locale}/blog/country-${post.cw_country.slug}`}>{post.cw_country.name}</a>)}
                                    {post.cw_region && (
                                        <a href={`/${pageContext.locale}/blog/region-${post.cw_region.slug}`}>{post.cw_region.name}</a>)}
                                    {post.cw_topic && (
                                        <a href={`/${pageContext.locale}/blog/topic-${post.cw_topic.slug}`}>{post.cw_topic.name}</a>)}
                                </p>
                                <div className="sidebar__social-list">
                                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${urlEncoded}`}><i
                                        className="fab fa-facebook-square"></i></a>
                                    <a href={`https://twitter.com/intent/tweet?url=${urlEncoded}&text=${post.Title}`}><i
                                        className="fab fa-twitter"></i></a>
                                    <a href={`https://pinterest.com/pin/create/button/?url=${urlEncoded}&media=&description=`}><i
                                        className="fab fa-pinterest-square"></i></a>
                                    <a href={`mailto:?&subject=Find-My-Beach post&cc=&bcc=&body=${post.Title}%0A${urlEncoded}%0A`}><i
                                        className="fab fa fa-envelope"></i></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <Sidebar pageContext={pageContext}/>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export const pageQuery = graphql`
  query ($id: Int, $language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    strapiPost(strapi_id: { eq: $id }) {
      id
      slug
      Title
      Description {
        data {
          childMarkdownRemark {
            html
          }
        }
      }
      Content {
        ...PostBlocks
      }
      cover {
        alternativeText
        formats {
          large {
            url
          }
        }
        url
      }
      cw_country {
        slug
        name
        country
      }
      cw_region {
        name
        slug
        region
      }
      cw_topic {
        name
        slug
        topic
      }
    }
  }
`

export default Post

export const Head = ({location, params, data, pageContext}) => {
    const post = data.strapiPost;

    const seo = {
        metaTitle: post.Title,
        metaDescription: post.Description?.data?.childMarkdownRemark?.html ?? "",
        shareImage: post.cover,
    };

    return (
        <Seo seo={seo} pageContext={pageContext}/>
    )
};
